
import styles from '../style.module.css';
import useCountUp from "../hooks/useCountUp";

function AdvantagesItem({ value, title, text, startAnimation }) {

    const number = useCountUp(value, startAnimation);
    const suffix = String(value).includes('+') ? '+' : '';
    const formattedNumber = number >= 1000
        ? String(number).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        : String(number);

    return (
        <div className={styles.advantages_item}>
            <span className={styles.advantages_item_value}>
                {formattedNumber}
                {suffix}
            </span>
            <span className={styles.advantages_item_title}>
                { title }
            </span>
            {text ? (
                <span className={styles.advantages_item_text}>
                    { text }
                </span>
            ) : null}
        </div>
    )
}

export default AdvantagesItem
